<div class="text-center w-100">
  <b>Downloading Metrics Report</b>
</div>